export const METRIKA_COUNTER_ID = 5120242;

/**
 * На первый взглядниже страшные функции, это копия паттерна, который используют:
 *
 * Яндекс.Метрика в своих CDN-скриптах (если открыть tag.js — увидишь те же обёртки);
 * Google Tag Manager (window.dataLayer и отложенная инициализация);
 * Hotjar / FullStory — тоже очередь + ленивый запуск.

 * То есть это стандартная «best practice» схема:
 * собрать события → подождать готовности библиотеки → отдать все разом.
 *
 * Lazy init (Метрика не стартует сразу, а ждёт первое взаимодействие → LCP и CPU стабильны)
 * */
export const analyticsScript = `
  // === Очередь событий до инициализации ===
  (function(w){
    w.__ymq = w.__ymq || []; // {t:'goal'|'hit', args:any[]}
    w.__ym_ready = false;
    w.__ym_init_called = false;
  })(window);

  // === Загрузка тега ===
  (function(m,e,t,r,i,k,a){
    m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) { if (document.scripts[j].src === r) { return; } }
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

  // === Инициализация счётчика + сброс очереди ===
  function __ymInit() {
    if (window.__ym_init_called) return; window.__ym_init_called = true;
    if (typeof window.ym !== 'function') { 
      // подождём пока тег поднимет ym
      var tryInit = function(){
        if (typeof window.ym === 'function') { __ymInit(); }
        else { setTimeout(tryInit, 60); }
      }; 
      return tryInit();
    }

    ym(${METRIKA_COUNTER_ID}, 'init', {
      clickmap: true,
      ecommerce: "dataLayer",
      trackLinks: true,
      webvisor: true,
      accurateTrackBounce: true,
    });

    window.__ym_ready = true;

    // Флаш очереди
    try {
      (window.__ymq || []).forEach(function(item){
        if (item.t === 'goal') {
          ym(${METRIKA_COUNTER_ID}, 'reachGoal', item.args[0], item.args[1]);
        } else if (item.t === 'hit') {
          ym(${METRIKA_COUNTER_ID}, 'hit', item.args[0], item.args[1] || {});
        }
      });
      window.__ymq = [];
    } catch(e) {}
  }

  // === Lazy init: сначала idle, иначе первое действие ===
  (function(){
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function(){ __ymInit(); }, { timeout: 1500 });
    } else {
      var once = function(){
        __ymInit();
        window.removeEventListener('scroll', once);
        window.removeEventListener('click', once);
        window.removeEventListener('keydown', once);
        window.removeEventListener('mousemove', once);
      };
      window.addEventListener('scroll', once, { once: true });
      window.addEventListener('click', once, { once: true });
      window.addEventListener('keydown', once, { once: true });
      window.addEventListener('mousemove', once, { once: true });
    }
  })();
`;
